import { OptionType } from "react-select";

export const getIsDuplicatedWithOptions = (selectOptions: OptionType[], inputValue: string) => {
  return Array.isArray(selectOptions) && selectOptions.map((selectOption) => selectOption.value).includes(inputValue);
};
